module.exports = __webpack_public_path__ + "img/you-have-got-a-package.9ddc645f.png";